var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "tit": "1:1 문의하기"
    }
  }, [_c('template', {
    slot: "contents"
  }, [_c('router-view', {
    attrs: {
      "name": "question"
    }
  })], 1)], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }